export enum OutlineType{
  SIDE = "SIDE",
  FRONT = "FRONT",
  TOP = "TOP"
}

export enum OutlineSetType {
  CABINET = "CABINET",
  ROUND_ELEMENT = "ROUND_ELEMENT"
}
